"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _core = require("@material-ui/core");

var _hooks = require("../../hooks");

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _core.makeStyles)(_styles.default, {
  name: 'Sidebar'
});

var Sidebar = function Sidebar(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      className = _ref.className,
      children = _ref.children;
  var classes = useStyles();
  var windowSize = (0, _hooks.useWindowSize)();
  return /*#__PURE__*/_react.default.createElement(_core.Drawer, {
    anchor: "left",
    color: "primary",
    variant: windowSize.isUpLg ? 'persistent' : 'temporary',
    classes: {
      paper: classes.drawer
    },
    onClose: onClose,
    open: windowSize.isUpLg || open
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.root, className)
  }, children));
};

var _default = Sidebar;
exports.default = _default;